import { createAsyncAction } from 'redux-promise-middleware-actions';
import api from '../Api/apiIS';
import { getActionTypesResult } from '../utils';

export const exportGoogleSheetsConstants = {
    SAVE_FOLDER_GOOGLE: 'SAVE_FOLDER_GOOGLE',
};

export const exportGoogleSheetsFulfilledConstants = getActionTypesResult(exportGoogleSheetsConstants, '_FULFILLED');
export const exportGoogleSheetsPendingConstants = getActionTypesResult(exportGoogleSheetsConstants, '_PENDING');
export const exportGoogleSheetsRejectedConstants = getActionTypesResult(exportGoogleSheetsConstants, '_REJECTED');

export const saveFolderInGoogle = createAsyncAction(exportGoogleSheetsConstants.SAVE_FOLDER_GOOGLE, folderId =>
    api.post(`expenseManagement/googleSheetsReport?folderId=${folderId}`).then(res => res.data)
);

export const saveFolderInGoogleDriveLicensePaymentsReport = createAsyncAction(
    exportGoogleSheetsConstants.SAVE_FOLDER_GOOGLE, ({ folderId, startDate, endDate, reportIntervalTime }) => api.get(`/licenses/googleSheets/licensePayments?folderId=${folderId}&startDate=${startDate}&endDate=${endDate}&reportIntervalTime=${reportIntervalTime.value}`)
        .then(res => res.data)
);

export const saveFolderInGoogleDriveDeviceAssignmentReport = createAsyncAction(
    exportGoogleSheetsConstants.SAVE_FOLDER_GOOGLE, data => api.get(`/deviceReport/deviceAssignmentReport`, { params: data, paramsSerializer: { indexes: null } })
        .then(res => res.data)
);

export const saveFolderInGoogleDriveDeviceUnassignmentReport = createAsyncAction(
    exportGoogleSheetsConstants.SAVE_FOLDER_GOOGLE, data => api.get(`/deviceReport/deviceUnassignmentReport`, { params: data, paramsSerializer: { indexes: null } })
        .then(res => res.data)
);

export const saveFolderInGoogleDriveOrderingReport = createAsyncAction(
    exportGoogleSheetsConstants.SAVE_FOLDER_GOOGLE, data => api.get(`/devices/orderedDevicesGoogleSheetsReport`, { params: data, paramsSerializer: { indexes: null } })
        .then(res => res.data)
);

export const saveFolderInGoogleDriveUserLicenseReviewReport = createAsyncAction(
    exportGoogleSheetsConstants.SAVE_FOLDER_GOOGLE, data => (api.get(`/licenseUserAssignment/googleSheetsReport`, { params: data, paramsSerializer: { indexes: null } })
        .then(res => res.data))
);

export const saveFolderInGoogleDriveVmLicenseReviewReport = createAsyncAction(
    exportGoogleSheetsConstants.SAVE_FOLDER_GOOGLE, data => (api.get(`/licenseVirtualMachineAssignment/googleSheetsReport`, { params: data, paramsSerializer: { indexes: null } })
        .then(res => res.data))
);

export const saveFolderInGoogleDriveIuLicenseReviewReport = createAsyncAction(
    exportGoogleSheetsConstants.SAVE_FOLDER_GOOGLE, data => (api.get(`/licenseDeviceAssignment/googleSheetsReport`, { params: data, paramsSerializer: { indexes: null } })
        .then(res => res.data))
);

export const saveFolderInGoogleDriveDevice = createAsyncAction(
    exportGoogleSheetsConstants.SAVE_FOLDER_GOOGLE, data => (api.get(`/devices/activeGoogleSheetsReport`, { params: data, paramsSerializer: { indexes: null } })
        .then(res => res.data))
);

export const saveFolderInGoogleDriveMobileDevice = createAsyncAction(
    exportGoogleSheetsConstants.SAVE_FOLDER_GOOGLE, data => (api.get(`/mobileDevices/activeGoogleSheetsReport`, { params: data, paramsSerializer: { indexes: null } })
        .then(res => res.data))
);

export const saveFolderInGoogleDriveLicense = createAsyncAction(
    exportGoogleSheetsConstants.SAVE_FOLDER_GOOGLE, data => (api.get(`/licenses/activeGoogleSheetsReport`, { params: data, paramsSerializer: { indexes: null } })
        .then(res => res.data))
);

export const saveFolderInGoogleDriveDeviceReportEisEcCompareDevice =
    createAsyncAction(exportGoogleSheetsConstants.SAVE_FOLDER_GOOGLE, folderId => api.get(`/devices/comparisonDevicesGoogleSheetsReport?folderId=${folderId}`)
        .then(res => res.data));

export const saveFolderInGoogleDrivePayments =
    createAsyncAction(exportGoogleSheetsConstants.SAVE_FOLDER_GOOGLE, ({ licenseId, folderId }) => api.get(`/license/schedule/report?LicenseId=${licenseId}&FolderId=${folderId}`)
        .then(res => res.data));

export const saveFolderInGoogleDriveEmployeeAssets =
    createAsyncAction(exportGoogleSheetsConstants.SAVE_FOLDER_GOOGLE, ({ userId, folderId }) => api.get(`/user/equipmentGoogleSheetsReport?userId=${userId}&FolderId=${folderId}`)
        .then(res => res.data));

export const saveFolderInGoogleDriveVirtualMachine = createAsyncAction(
    exportGoogleSheetsConstants.SAVE_FOLDER_GOOGLE, data => (api.get(`/vm/activeGoogleSheetsReport`, { params: data, paramsSerializer: { indexes: null } })
        .then(res => res.data))
);

export const saveFolderInGoogleDriveDevicesArchive =
    createAsyncAction(exportGoogleSheetsConstants.SAVE_FOLDER_GOOGLE, folderId => api.get(`/devices/archiveGoogleSheetsReport?folderId=${folderId}`)
        .then(res => res.data));

export const saveFolderInGoogleDriveDeviceAssignmentReasonArchive =
    createAsyncAction(exportGoogleSheetsConstants.SAVE_FOLDER_GOOGLE, folderId => api.get(`/deviceAssignmentReason/archiveGoogleSheetsReport?folderId=${folderId}`)
        .then(res => res.data));

export const saveFolderInGoogleDriveMobileDevicesArchive =
    createAsyncAction(exportGoogleSheetsConstants.SAVE_FOLDER_GOOGLE, folderId => api.get(`/mobileDevices/archiveGoogleSheetsReport?folderId=${folderId}`)
        .then(res => res.data));

export const saveFolderInGoogleDriveLicensesArchive =
    createAsyncAction(exportGoogleSheetsConstants.SAVE_FOLDER_GOOGLE, folderId => api.get(`/licenses/archiveGoogleSheetsReport?folderId=${folderId}`)
        .then(res => res.data));

export const saveFolderInGoogleDriveVirtualMachinesArchive =
    createAsyncAction(exportGoogleSheetsConstants.SAVE_FOLDER_GOOGLE, folderId => api.get(`/vm/archiveGoogleSheetsReport?folderId=${folderId}`)
        .then(res => res.data));

export const saveFolderInGoogleDriveLicenseProductNameArchive =
    createAsyncAction(exportGoogleSheetsConstants.SAVE_FOLDER_GOOGLE, folderId => api.get(`/licenseProductName/archiveGoogleSheetsReport?folderId=${folderId}`)
        .then(res => res.data));

export const saveFolderInGoogleDriveLicenseProductVersionArchive =
    createAsyncAction(exportGoogleSheetsConstants.SAVE_FOLDER_GOOGLE, folderId => api.get(`/licenseProductVersion/archiveGoogleSheetsReport?folderId=${folderId}`)
        .then(res => res.data));

export const saveFolderInGoogleDriveLicenseProductAttributeArchive =
    createAsyncAction(exportGoogleSheetsConstants.SAVE_FOLDER_GOOGLE, folderId => api.get(`/licenseProductAttribute/archiveGoogleSheetsReport?folderId=${folderId}`)
        .then(res => res.data));
